module.exports = __webpack_public_path__ + "img/logo_main.e533c3f6.png";